export default "__VITE_ASSET__CrJxZbw3__"